import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import ApartmentIcon from '@mui/icons-material/Apartment';
import SchoolIcon from '@mui/icons-material/School';
import AssignmentIcon from '@mui/icons-material/Assignment';
import VerifiedIcon from '@mui/icons-material/Verified';

const categories = [
  {
    icon: BusinessCenterIcon,
    title: 'Business Administration',
    subtitle: 'Learn to Manage',
    color: '#E53935',
  },
  {
    icon: AutoStoriesIcon,
    title: 'Liberal Arts',
    subtitle: 'Liberal Arts Degree',
    color: '#E53935',
  },
  {
    icon: SchoolIcon,
    title: 'Level Up',
    subtitle: 'Improve Your Skills',
    color: '#1A237E',
  },
  {
    icon: AssignmentIcon,
    title: 'Standardized Tests',
    subtitle: 'Test your Knowledge',
    color: '#1A237E',
  },
  {
    icon: VerifiedIcon,
    title: 'Certifications',
    subtitle: 'Get Certified',
    color: '#1A237E',
  },
];

const statistics = [
  { number: '8106', label: 'Success Stories' },
  { number: '6100', label: 'Happy Students' },
  { number: '6180', label: 'Expert Instructors' },
  { number: '8166', label: 'Total Courses' },
];

const Browse = () => {
  return (
    <Box sx={{ backgroundColor: '#F5F5F5', py: 0 }}>
      {/* Main Section with Left Text and Right Cards */}
      <Container maxWidth="xl" disableGutters>
        <Grid container spacing={0}>
          {/* Left Side - White Panel with Text */}
          <Grid 
            item 
            xs={12} 
            md={4}
            sx={{
              backgroundColor: 'white',
              display: 'flex',
              alignItems: 'center',
              p: { xs: 4, md: 6, lg: 8 },
              minHeight: { xs: 'auto', md: '600px' },
            }}
          >
            <Box sx={{ maxWidth: '500px' }}>
              <Typography
                variant="overline"
                sx={{
                  color: '#E53935',
                  fontSize: '0.75rem',
                  fontWeight: 500,
                  letterSpacing: 1.5,
                  mb: 2,
                  display: 'block',
                  textTransform: 'none',
                }}
              >
                Checkout All Categories List
              </Typography>
              
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2rem', md: '2.5rem', lg: '3rem' },
                  fontWeight: 700,
                  color: '#000000',
                  lineHeight: 1.2,
                  mb: 3,
                  fontFamily: '"Playfair Display", serif',
                }}
              >
                Let's Browse Our Associate Degrees and Courses
              </Typography>
              
              <Typography
                variant="body1"
                sx={{
                  color: '#757575',
                  fontSize: '0.95rem',
                  lineHeight: 1.8,
                }}
              >
                Explore a wide range of categories designed to help you achieve your academic and professional goals. Whether you're looking to enhance your skills or embark on a new career path, we have the perfect program for you.
              </Typography>
            </Box>
          </Grid>

          {/* Right Side - Category Cards Grid */}
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
                gap: { xs: 1.5, md: 2 },
                height: '100%',
                p: { xs: 2, md: 3 },
              }}
            >
              {categories.map((category, index) => (
                <Box
                  key={index}
                  sx={{
                    backgroundColor: category.color,
                    color: 'white',
                    aspectRatio: '1/1',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    p: { xs: 2.5, md: 3 },
                    borderRadius: 0,
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    '&:hover': {
                      transform: 'scale(1.05)',
                      zIndex: 10,
                      boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
                    },
                  }}
                >
                  {/* Icon Circle */}
                  <Box
                    sx={{
                      width: { xs: 60, md: 70, lg: 75 },
                      height: { xs: 60, md: 70, lg: 75 },
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.15)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 2,
                      border: '2px solid rgba(255, 255, 255, 0.3)',
                    }}
                  >
                    <category.icon sx={{ fontSize: { xs: 35, md: 40 } }} />
                  </Box>
                  
                  {/* Title */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '0.9rem', md: '1rem', lg: '1.05rem' },
                      lineHeight: 1.3,
                      mb: 0.5,
                      textTransform: category.title === 'standardized tests' ? 'lowercase' : 'none',
                    }}
                  >
                    {category.title}
                  </Typography>
                  
                  {/* Subtitle */}
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: { xs: '0.7rem', md: '0.8rem' },
                      opacity: 0.9,
                      fontWeight: 400,
                    }}
                  >
                    {category.subtitle}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Browse;